export const footer = {
  contact: "Contacto",
  phone1: "986 369 778",
  phone2: "676 367 580",
  email: "info@gandaraschool.com",
  address1: "Lugar de Moureira, 1, Mañufe",
  address2: "36388 Gondomar (Pontevedra)",
  schedule: "Horario",
  weekdays: "Lunes a Viernes",
  hours: "8:15 - 17:00",
  follow: "Síguenos",
  slogan: "Aprendizaje vivencial, trilingüe y activo",
  theSchool: "El Colegio",
  admissions: "Admisiones",
  activities: "Actividades",
  viewOnMap: "Ver en Google Maps",
  bookVisitCta: "Reservar visita",
  allRightsReserved: "Todos los derechos reservados",
  links: {
    aboutUs: "Quiénes Somos",
    montessori: "Método Montessori",
    trilingual: "Educación Trilingüe",
    services: "Servicios",
    extracurriculars: "Extraescolares",
    admissionProcess: "Proceso de Admisión",
    prices: "Precios y Tarifas",
    visitSchool: "Visita el Colegio",
    openHouse: "Jornada de Puertas Abiertas",
    birthdays: "Cumpleaños",
    easterCamp: "Campamento Semana Santa",
    summerCamp: "Campamento Verano",
    courses: "Cursos"
  }
};
